import { render, staticRenderFns } from "./VuesticFileUploadList.vue?vue&type=template&id=725ea5d9"
import script from "./VuesticFileUploadList.vue?vue&type=script&lang=js"
export * from "./VuesticFileUploadList.vue?vue&type=script&lang=js"
import style0 from "./VuesticFileUploadList.vue?vue&type=style&index=0&id=725ea5d9&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('725ea5d9')) {
      api.createRecord('725ea5d9', component.options)
    } else {
      api.reload('725ea5d9', component.options)
    }
    module.hot.accept("./VuesticFileUploadList.vue?vue&type=template&id=725ea5d9", function () {
      api.rerender('725ea5d9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vuestic-theme/vuestic-components/vuestic-file-upload-kyc/VuesticFileUploadList.vue"
export default component.exports